// extracted by mini-css-extract-plugin
module.exports = {"container":"HowItWorks_container__5FptX","link":"HowItWorks_link__QzUtC"};